import React, { useEffect, useState } from 'react';

import classNames from 'classnames';

import {
    Link,
    Toast,
    Typography,
    WDSButton,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import events from './events';

import styles from './Survey.scss';

const Survey = ({ t }) => {
    // const [showThankYou, setShowThankYou] = useState(false);
    const [showToast, setShowToast] = useState(false);

    useEffect(() => {
        let timeout;

        if (!sessionStorage.getItem('surveyShown')) {
            timeout = setTimeout(() => {
                setShowToast(true);
            }, 15000);
        }

        return () => clearTimeout(timeout);
    }, []);

    return (showToast
        && <Toast anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }} className={styles.toast} onHide={() => sessionStorage.setItem('surveyShown', true)} showInline >
            We’d love to meet you. <Link href="https://calendar.app.google/uzNxeafZmrqTf1AX7" rel="noopener noreferrer" target="_blank">Come talk with our product team</Link>

            {/* {!showThankYou
                ? <Question setShowThankYou={setShowThankYou} t={t} />
                : <Typography variant="body1">Thank you for taking the time to provide your feedback!</Typography>
            } */}
        </Toast>
    );
};

const Question = ({ setShowThankYou, t }) => {
    const [score, setScore] = useState(null);

    const onScoreChange = (value) => {
        setScore(value);
        sessionStorage.setItem('surveyShown', true);
        events.clickScoreEvent(value);

        if (value === 'yes') {
            setShowThankYou(true);
        }
    };

    return (
        !score
            ? <Score onScoreChange={onScoreChange} t={t} />
            : <Negative score={score} setShowThankYou={setShowThankYou} t={t} />
    );
};

const Score = ({ onScoreChange }) => {
    return (
        <div>
            <Typography variant="body1">Are you finding what you&apos;re looking for?</Typography>
            <div className={styles.buttonGroup}>
                <WDSButton onClick={() => onScoreChange('yes')}>Yes</WDSButton>
                <WDSButton onClick={() => onScoreChange('no')}>No</WDSButton>
            </div>
        </div>
    );
};

const Negative = ({
    t, setShowThankYou, score,
}) => {
    const [selectedOption, setSelectedOption] = useState(null);
    const [showMore, setShowMore] = useState(null);

    const onOptionSubmit = () => {
        setShowMore(true);
        events.submitDropdownEvent(selectedOption);
    };

    const options = [
        {
            id: 'times',
            label: 'The best departure/arrival times',
        },
        {
            id: 'prices',
            label: 'The best prices for my budget',
        },
        {
            id: 'stations',
            label: 'The best stations for my plans',
        },
        {
            id: 'carrier',
            label: 'The best bus/train carrier for my needs',
        },
        {
            id: 'trips',
            label: 'Any trips for my route or departure date',
        },
        {
            id: 'other',
            label: 'Other',
        },
    ];

    return (
        showMore
            ? (
                <Feedback
                    score={score}
                    selectedOption={selectedOption}
                    setShowThankYou={setShowThankYou}
                    t={t}
                />)
            : <>
                <Typography variant="body1">What are you struggling to find?</Typography>
                <div className={styles.flex} >
                    <div className={styles.selectContainer}>
                        <select
                            className={classNames(styles.select, {
                                [styles.hasValue]: !!selectedOption,
                            })}
                            onChange={e => setSelectedOption(e.target.value)}
                            value={selectedOption || ''}
                        >
                            <option
                                value=""
                                disabled
                            >
                                Select...
                            </option>
                            {options.map(({ id, label }) => (
                                <option
                                    key={id}
                                    value={id}
                                >
                                    {label}
                                </option>
                            ))}
                        </select>
                    </div>
                    <WDSButton disabled={!selectedOption} onClick={onOptionSubmit}>{t('nps-submit-button')}</WDSButton>
                </div>
            </>
    );
};

const Feedback = ({
    selectedOption, setShowThankYou, score, t,
}) => {
    const [feedback, setFeedback] = useState('');

    const onSubmit = () => {
        setShowThankYou(true);
        events.submitFeedbackEvent({
            feedback,
            score,
            selected_option: selectedOption,
        });
    };

    const title = selectedOption === 'other'
        ? 'What are you struggling to find?'
        : '(Optional) Anything to add to help us better understand the problem?';

    return (
        <>
            <Typography variant="body1">{title}</Typography>
            <textarea
                className={styles.textarea}
                onChange={(e) => setFeedback(e.target.value)}
                value={feedback}
            />
            <WDSButton onClick={onSubmit} >{t('nps-submit-button')}</WDSButton>
        </>
    );
};

export default localize(Survey, 'baseApp');
